import { IAppContext } from 'App/AppContext';
import { IPeriodFilterData, PeriodFilterDataOption } from 'components/Filter/PeriodFilter';
import { getPeriodFilter } from 'components/Filter/PeriodFilterHelper';
import { AuditCriteriaPeriodKind } from 'models/auditCriteriaGeneric';
import { AuditCriteriaPeriod } from 'models/auditCriteriaValues';
import { AuditYearStart } from 'models/setting';
import { getCurrentAuditYear } from 'utils/datetime';

/**
 * The criteria period of a PeriodFilter choice (PLAN-CTI-088, spec 7.2): All is the latest answer; the current and
 * the previous audit year stay kinds of their own, which the API resolves itself; any other audit year, the last
 * week, month, quarter or year, and a custom range are a Custom window.
 */
export const toAuditCriteriaPeriod = (data: IPeriodFilterData, appContext: IAppContext): AuditCriteriaPeriod => {
  if (data.option === PeriodFilterDataOption.All) return new AuditCriteriaPeriod();

  if (data.option === PeriodFilterDataOption.AuditYear) {
    const currentYear = getCurrentAuditYear(appContext.globalDataCache.settings.get(AuditYearStart) as string);
    // a year of 0 or none is the current audit year, as PeriodFilter resolves it
    const year = data.auditYear || currentYear;
    if (year === currentYear) return new AuditCriteriaPeriod(AuditCriteriaPeriodKind.AuditYear);
    if (year === currentYear - 1) return new AuditCriteriaPeriod(AuditCriteriaPeriodKind.PreviousAuditYear);
  }

  const { start, end } = getPeriodFilter(data, appContext);

  return new AuditCriteriaPeriod(AuditCriteriaPeriodKind.Custom, start, end);
};
